import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageUnavailableError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageUnavailableError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
});

export type S3StorageUnavailableError = z.infer<
  typeof S3StorageUnavailableError
>;
